import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import ButtonDefault from '../../buttons/ButtonDefault';

import ConfirmPatientInfoModal from '../../modals/ConfirmPatientInfoModal';

import { getShowConfirmPatientInfoModal } from '../../../modules/viewer/selectors';
import setShowConfirmPatientInfoModal from '../../../modules/viewer/setShowConfirmPatientInfoModal';

export default function ConfirmPatientInfoBtn({ volID, volName, scanName }) {
  const dispatch = useDispatch();

  const show = useSelector(({ viewer }) => getShowConfirmPatientInfoModal(viewer));

  return (
    <>
      <ConfirmBtn onClick={() => dispatch(setShowConfirmPatientInfoModal(true))}>
        Confirm Patient Info
      </ConfirmBtn>
      <ConfirmPatientInfoModal
        volID={volID}
        volName={volName}
        scanName={scanName}
        show={show}
        onClose={() => {
          dispatch(setShowConfirmPatientInfoModal(false));
        }}
      />
    </>
  );
}

ConfirmPatientInfoBtn.propTypes = {
  scanName: PropTypes.string.isRequired,
  volID: PropTypes.string.isRequired,
  volName: PropTypes.string.isRequired,
};

const ConfirmBtn = styled(ButtonDefault)`
  width: 215px;
  height: 100%;
  background-image: linear-gradient(to bottom, #2f64c4, #172e58);

  :hover {
    background-image: none;
    background-color: #2f64c4;
  }

  :active {
    background-image: none;
    border: solid 1px #2f64c4;
    background-color: #182f5a;
  }

  :disabled {
    background-image: none;
    border: solid 1px #2f64c4;
    background-color: #2f64c4;
    opacity: 0.5;
  }
`;
